import z from 'zod'

import { nouhinshoDocumentNameText } from './classifications/nouhinsho'
import { othersDocumentNameText } from './classifications/others'
import { tobuKenzaiHoukokusyoDocumentNameText } from './classifications/tobuKenzaiHoukokusyo'
import { todaEnkabutsuDocumentNameText } from './classifications/todaEnkabutsu'
import { todaFreshDocumentNameText } from './classifications/todaFresh'
import { todaHoukokusyoDocumentNameText } from './classifications/todaHoukokuyso'
import { todaSeisekisyoDocumentNameText } from './classifications/todaSeisekisyo'

// 帳票名
export const documentNameSchema = z.enum([
  todaSeisekisyoDocumentNameText,
  todaFreshDocumentNameText,
  todaEnkabutsuDocumentNameText,
  todaHoukokusyoDocumentNameText,
  tobuKenzaiHoukokusyoDocumentNameText,
  nouhinshoDocumentNameText,
  othersDocumentNameText,
])
export type DocumentName = z.infer<typeof documentNameSchema>
